import React from 'react';
import { Grid } from '@fiverr-private/layout_components';
import type { Banner } from '@fiverr-private/store_builder_types';
import { BannerCard } from '../banner-card/BannerCard';

interface BannerGridProps {
    bannersToDisplay: Banner[];
    selectedBanners: Banner[];
    handleBannerClick: (bannerId: string) => void;
}

export const BannerGrid = ({ bannersToDisplay, selectedBanners, handleBannerClick }: BannerGridProps) => (
    <Grid
        width={{
            default: 311,
            sm: 552,
        }}
        gap="3"
        templateColumns={{
            default: '50%_50%',
            sm: '33%_33%_33%',
        }}
    >
        {bannersToDisplay.map((banner) => {
            const isSelected = selectedBanners?.some((selectedBanner) => selectedBanner.id === banner.id) || false;

            return (
                <BannerCard
                    key={banner.id}
                    banner={banner}
                    isSelected={isSelected}
                    handleBannerClick={handleBannerClick}
                />
            );
        })}
    </Grid>
);
